import { Link } from "@remix-run/react";
import { clsx } from "clsx";

import { SpriteName, Svg } from "./svg";

export const socialMediaProfiles: Array<{
  title: string;
  href: string;
  icon: SpriteName;
}> = [
  {
    title: "GitHub",
    href: "https://github.com/bmcreations",
    icon: "github",
  },
  {
    title: "Instagram",
    href: "https://instagram.com/bmcreationsdev",
    icon: "instagram",
  },
  {
    title: "Facebook",
    href: "https://facebook.com/bmcreationsdev",
    icon: "facebook",
  },
];

export function SocialMedia({ className }: { className?: string }) {
  return (
    <ul className={clsx("flex gap-x-8 text-ink-300", className)}>
      {socialMediaProfiles.map((profile) => (
        <li key={profile.title}>
          <Link
            to={profile.href}
            aria-label={profile.title}
            className="transition hover:text-ink-50"
          >
            <Svg
              name={profile.icon}
              className="h-6 w-6 fill-current"
              aria-hidden="true"
            />
          </Link>
        </li>
      ))}
    </ul>
  );
}
